"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const ServiceLocator_1 = __importDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
const ThemeContext_1 = require("chaire-lib-frontend/lib/contexts/ThemeContext");
const project_config_1 = __importDefault(require("chaire-lib-common/lib/config/shared/project.config"));
// TODO Menu items should not be provided directly by widgets, it should be
// built from descriptive elements, or contributions should register their own
// menu. This is just a copy-paste from the legacy workspace.
const MenuBar = (props) => {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)(['transit', 'main', 'form']);
    // Get the sections configuration
    const sectionsConfig = (_a = project_config_1.default.sections) !== null && _a !== void 0 ? _a : {};
    // Get the current theme (light or dark)
    const theme = (0, react_1.use)(ThemeContext_1.ThemeContext);
    const sectionIcon = (sectionShortname) => {
        const section = sectionsConfig[sectionShortname];
        return theme === 'dark' ? section.iconWhite : section.iconBlack;
    };
    const onClickHandler = function (e) {
        e.preventDefault();
        const sectionShortname = e.currentTarget.getAttribute('data-section');
        ServiceLocator_1.default.eventManager.emit('section.change', sectionShortname, sectionsConfig[sectionShortname].showFullSizePanel);
    };
    const sectionLists = [];
    for (const sectionShortname in sectionsConfig) {
        if (sectionsConfig[sectionShortname].enabled !== false) {
            sectionLists.push(react_1.default.createElement("li", { className: "tr__left-menu-element", key: sectionShortname },
                react_1.default.createElement("button", { className: `tr__left-menu-button${props.activeSection === sectionShortname ? ' active' : ''}`, "data-section": sectionShortname, onClick: onClickHandler },
                    react_1.default.createElement("span", { className: "tr__left-menu-button-icon" },
                        react_1.default.createElement("img", { className: "_icon", src: sectionIcon(sectionShortname), alt: t(sectionsConfig[sectionShortname].localizedTitle) })),
                    react_1.default.createElement("span", { className: "tr__left-menu-button-name" }, t(sectionsConfig[sectionShortname].localizedTitle)))));
        }
    }
    return react_1.default.createElement("ul", { className: "tr__left-menu-container" }, sectionLists);
};
exports.default = MenuBar;
//# sourceMappingURL=TransitionMenuBar.js.map